module.exports = __webpack_public_path__ + "img/IMG_6689_L_Wood_MockedUp.c4d7b2c5.jpg";